var DIC = {
  WEEK: [
    {
      label: '周一',
      value: '1',
    },
    {
      label: '周二',
      value: '2',
    },
    {
      label: '周三',
      value: '3',
    },
    {
      label: '周四',
      value: '4',
    },
    {
      label: '周五',
      value: '5',
    },
    {
      label: '周六',
      value: '6',
    },
    {
      label: '周天',
      value: '7',
    },
  ],
  MONTH: [
    {
      label: '1',
      value: '1',
    },
    {
      label: '2',
      value: '2',
    },
    {
      label: '3',
      value: '3',
    },
    {
      label: '4',
      value: '4',
    },
    {
      label: '5',
      value: '5',
    },
    {
      label: '6',
      value: '6',
    },
    {
      label: '7',
      value: '7',
    },
    {
      label: '8',
      value: '8',
    },
    {
      label: '9',
      value: '9',
    },
    {
      label: '10',
      value: '10',
    },
    {
      label: '11',
      value: '11',
    },
    {
      label: '12',
      value: '12',
    },
    {
      label: '13',
      value: '13',
    },
    {
      label: '14',
      value: '14',
    },
    {
      label: '15',
      value: '15',
    },
    {
      label: '16',
      value: '16',
    },
    {
      label: '17',
      value: '17',
    },
    {
      label: '18',
      value: '18',
    },
    {
      label: '19',
      value: '19',
    },
    {
      label: '20',
      value: '20',
    },
    {
      label: '21',
      value: '21',
    },
    {
      label: '22',
      value: '22',
    },
    {
      label: '23',
      value: '23',
    },
    {
      label: '24',
      value: '24',
    },
    {
      label: '25',
      value: '25',
    },
    {
      label: '26',
      value: '26',
    },
    {
      label: '27',
      value: '27',
    },
    {
      label: '28',
      value: '28',
    },
    {
      label: '29',
      value: '29',
    },
    {
      label: '30',
      value: '30',
    },
    {
      label: '31',
      value: '31',
    },
  ],
};
export default {
  submitText: '提交',
  emptyBtn: false,
  submitBtn: false,
  labelWidth: 120,
  group: [
    {
      dialogDirection: 'rtl',
      dialogType: 'drawer',
      label: '计划',
      arrow: false,
      column: [
        {
          label: '计划名称',
          prop: 'planName',
          disabled: true,
        },
        {
          label: '计划日期',
          prop: 'planTimeRange',
          searchRange: true,
          type: 'daterange',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          disabled: true,
        },
      ],
    },
    {
      dialogDirection: 'rtl',
      label: '时间',
      arrow: false,
      column: [
        {
          label: '巡检周期',
          prop: 'inspectCycleType',
          type: 'radio',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=inspect_cycle_type',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '具体时间',
          prop: 'detailTimeWeek',
          type: 'checkbox',
          dicData: DIC.WEEK,
          span: 24,
          display: false,
          disabled: true,
        },
        {
          label: '具体时间',
          prop: 'detailTimeMonth',
          type: 'checkbox',
          all: true,
          dicData: DIC.MONTH,
          span: 24,
          display: false,
          disabled: true,
        },
        {
          label: '巡视开始时间',
          prop: 'inspectBeginTime',
          type: 'datetime',
          format: 'yyyy-MM-dd HH:mm:ss',
          valueFormat: 'yyyy-MM-dd HH:mm:ss',
          display: false,
          disabled: true,
        },
        {
          label: '巡检天数',
          prop: 'num',
          type: 'number',
          display: false,
          disabled: true,
        },
        {
          label: '周期休息天数（天）',
          prop: 'intervalTime',
          type: 'number',
          display: false,
          disabled: true,
        },
        {
          label: '允许逾期',
          prop: 'staleDatedStatus',
          type: 'radio',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=stale_dated_status',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '逾期时间(分钟)',
          prop: 'beyondTheTime',
          type: 'number',
          display: false,
          disabled: true,
        },
        // {
        //   type: 'dynamic',
        //   label: '时间段',
        //   span: 24,
        //   display: true,
        //   disabled: true,
        //   children: {
        //     align: 'center',
        //     headerAlign: 'center',
        //     addBtn: true,
        //     delBtn: true,
        //     column: [
        //       {
        //         type: 'time',
        //         label: '开始',
        //         span: 24,
        //         format: 'HH:mm',
        //         valueFormat: 'HH',
        //         prop: 'start',
        //         rules: [
        //           {
        //             required: true,
        //             message: '开始时间不能为空',
        //             trigger: 'blur',
        //           },
        //         ],
        //       },
        //       {
        //         type: 'time',
        //         label: '结束',
        //         span: 24,
        //         format: 'HH:mm',
        //         valueFormat: 'HH',
        //         prop: 'end',
        //         rules: [
        //           {
        //             required: true,
        //             message: '结束时间不能为空',
        //             trigger: 'blur',
        //           },
        //         ],
        //       },
        //     ],
        //   },
        //   prop: 'time',
        //   rules: [
        //     {
        //       required: true,
        //       message: '请选择时间段',
        //       trigger: 'blur',
        //     },
        //   ],
        // },
        {
          label: '时间段',
          span: 24,
          row: true,
          prop: 'time',
          formslot: true,
          typeslot: true,
          labelslot: true,
        },
      ],
    },
    {
      dialogDirection: 'rtl',
      label: '巡检点',
      arrow: false,
      column: [
        {
          label: '班组名称',
          prop: 'groupId',
          type: 'tree',
          dicUrl: 'api/inspectGroup/inspectGroupTree',
          props: { label: 'groupName', value: 'id' },
          disabled: true,
        },
        {
          label: '巡检点名称',
          prop: 'nodeId',
          type: 'tree',
          dataType: 'string',
          multiple: true,
          dicUrl: 'api/inspectNode/inspectNodeTree',
          props: { label: 'nodeName', value: 'id' },
          disabled: true,
        },
        {
          prop: 'crud1',
          label: '巡检项',
          formslot: true,
          span: 24,
          disabled: true,
        },
      ],
    },
  ],
};
